import { StoreData } from "./store.data";
import { CategorySource } from "@bitwarden/web-vault/app/models/types/category.types";

export type CategoryModelVersion = 2;
export interface CategoryStoreModel extends StoreData {
  /** **Date structure Version Number** **/
  v: CategoryModelVersion;

  /** category name */
  n: string;

  /** category is generate default */
  gd: boolean; // when we import data and create accounts if there are no category-renderer related to transaction

  sc: CategorySource; // synced to external source
}

export const DefaultCategoryStoreModel: CategoryStoreModel = {
  dc: "",
  dm: "",
  gd: false,
  sc: "manual",
  id: "",
  n: "",
  v: 2,
  vid: "",
};
